import moment from "moment";

export class TimeEntriesParams {
    public from: moment.Moment = moment().subtract(7, 'd');
    public to: moment.Moment = moment();
    public holidayAndLeaves = false;
    public time_entries_id = "";

    public constructor(init?: Partial<TimeEntriesParams>) {
        Object.assign(this, init);
    }
}